module.exports = __webpack_public_path__ + "img/detail_btn.350fe634.png";